<template>
  <v-container fill-height class="ma-0 navbar">
    <v-img 
      :src="logo"
      height="34"
      width="100"
      class="mx-auto d-none d-md-block">
    </v-img>
    <v-list nav width="100%" class="pa-0 mx-0 list-bg" color="white">
      <v-list-item-group v-model="group">
        <v-list-item id="elem_home_be" disabled class="d-none"> </v-list-item>
        <v-list-item
          link
          class="navbar-item"
          color="light"
          :id="'elem_' + items[0].name"
          :to="items[0].path"
        >
            <v-row
              class="mx-0 selected"
              color="light"
              v-show="selected === 0"
            >
              <v-col
                cols="12"
                class="ma-0 py-0 px-0"
              >
                <v-img :src="items[0].icon" width="54" height="54" class="mx-auto"></v-img>
              </v-col>
              <v-col cols="12" class="ma-0 pb-3 py-1 d-none d-sm-block">
                <v-list-item-title
                    class="text-caption title-es"
                    >{{ items[0].title }}</v-list-item-title
                >
                <v-list-item-title
                    class="font-italic text-caption text-md-body-2"
                    >{{ items[0].trasl }}</v-list-item-title
                >
              </v-col>
            </v-row>
            <v-row
              class="mx-0"
              color="light"
              v-show="selected !== 0"
            >
              <v-col
                cols="12"
                class="ma-0 py-0 px-0"
              >
                <v-img :src="items[0].iconW" width="54" height="54" class="mx-auto"></v-img>
              </v-col>
              <v-col cols="12" class="py-0 d-none d-sm-block">
                <v-list-item-title
                  class="text-caption title-es"
                  >{{ items[0].title }}</v-list-item-title
                >
                <v-list-item-title
                  class="font-italic text-caption text-md-body-2"
                  >{{ items[0].trasl }}</v-list-item-title
                >
              </v-col>
            </v-row>
        </v-list-item>
        <v-list-item id="elem_home_af" disabled class="d-none"> </v-list-item>
      
        <v-list-item id="elem_list_fi" disabled class="d-none"> </v-list-item>

        <v-list-item
            link
            class="navbar-item"
            color="light"
            :id="'elem_' + items[1].name"
            :to="items[1].path"
        >
          <v-row
              class="mx-0 selected"
              color="light"
              v-show="selected === 1"
          >
            <v-col
                cols="12"
                class="py-0"
            >
              <v-img :src="items[1].icon" width="54" height="54" class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" class="py-0 d-none d-sm-block">
              <v-list-item-title
                class="text-caption title-es"
                >{{ items[1].title }}</v-list-item-title
              >
              <v-list-item-title
                class="font-italic text-caption text-md-body-2"
                >{{ items[1].trasl }}</v-list-item-title
              >
            </v-col>
          </v-row>
          <v-row
              class="mx-0"
              color="light"
              v-show="selected !== 1"
          >
            <v-col
              cols="12"
              class="py-0"
            >
              <v-img :src="items[1].iconW" width="54" height="54" class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" class="py-0 d-none d-sm-block">
              <v-list-item-title
                class="text-caption title-es"
                >{{ items[1].title }}</v-list-item-title
              >
              <v-list-item-title
                class="font-italic text-caption text-md-body-2"
                >{{ items[1].trasl }}</v-list-item-title
              >
            </v-col>
          </v-row>
        </v-list-item>

        <v-list-item
          link
          class="navbar-item"
          color="light"
          :id="'elem_' + items[2].name"
          :to="items[2].path"
        >
          <v-row
            class="mx-0 selected"
            color="light"
            v-show="selected === 2"
          >
            <v-col
              cols="12"
              class="py-0"
            >
              <v-img :src="items[2].icon" width="54" height="54" class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" class="ma-0 py-1 pl-0 pr-0 d-none d-sm-block">
              <v-list-item-title
                class="text-caption title-es"
                >{{ items[2].title }}</v-list-item-title
              >
              <v-list-item-title
                class="font-italic text-caption text-md-body-2"
                >{{ items[2].trasl }}</v-list-item-title
              >
            </v-col>
          </v-row>
          <v-row
            class="mx-0"
            color="light"
            v-show="selected !== 2"
          >
            <v-col
              cols="12"
              class="py-0"
            >
              <v-img :src="items[2].iconW" width="54" height="54" class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" class="ma-0 py-1 pl-0 pr-0 d-none d-sm-block">
              <v-list-item-title
                class="text-caption title-es"
                >{{ items[2].title }}</v-list-item-title
              >
              <v-list-item-title
                class="font-italic text-caption text-md-body-2"
                >{{ items[2].trasl }}</v-list-item-title
              >
            </v-col>
          </v-row>
        </v-list-item>

        <v-list-item
          link
          class="navbar-item"
          color="light"
          :id="'elem_' + items[3].name"
          :to="items[3].path"
        >
          <v-row
            class="mx-0 selected"
            color="light"
            v-show="selected === 3"
          >
            <v-col
              cols="12"
              class="py-0"
            >
              <v-img :src="items[3].icon" width="54" height="54" class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" class="ma-0 pl-0 py-1 pl-0 pr-0 d-none d-sm-block">
              <v-list-item-title
                class="text-caption title-es"
                >{{ items[3].title }}</v-list-item-title
              >
              <v-list-item-title
                class="font-italic text-caption text-md-body-2"
                >{{ items[3].trasl }}</v-list-item-title
              >
            </v-col>
          </v-row>
          <v-row
            class="mx-0"
            color="light"
            v-show="selected !== 3"
          >
            <v-col
              cols="12"
              class="py-0"
            >
              <v-img :src="items[3].iconW" width="54" height="54" class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" class="ma-0 pl-0 py-1 pl-0 pr-0 d-none d-sm-block">
              <v-list-item-title
                  class="text-caption title-es"
                  >{{ items[3].title }}</v-list-item-title
              >
              <v-list-item-title
                  class="font-italic text-caption text-md-body-2"
                  >{{ items[3].trasl }}</v-list-item-title
              >
            </v-col>
          </v-row>
        </v-list-item>

        <v-list-item id="elem_list_la" disabled class="d-none"> </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-list width="100%" class="pa-0 mx-0 d-none d-md-block">
      <v-list-item-group>
        <v-list-item link class="py-1 py-md-3 px-0 ma-0" @click="logOut">
          <v-row>
            <v-col
                cols="12"
                class="py-0"
            >
              <v-img :src="items[4].icon" width="54" height="54" class="mx-auto"></v-img>
            </v-col>
            <v-col cols="12" class="ma-0 py-1 px-0">
              <v-list-item-title
                class="text-caption title-es"
                >{{ items[4].title }}</v-list-item-title
              >
              <v-list-item-title
                class="font-italic text-caption text-md-body-2"
                >{{ items[4].trasl }}</v-list-item-title
              >
            </v-col>
          </v-row>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
import accessHistory from '@/services/accessHistory'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            elementBeforeHome: {},
            elementHome: {},
            elementAfterHome: {},
            elementLibrary: {},
            elementChallenge: {},
            elementStore: {},
            selected: null,
            group: null,
            logo: require('@/assets/img/brand/logo.svg'),
            homeIcon: require('@/assets/img/icons/navbar/home.png'),
            homeIconActive: require('@/assets/img/icons/navbar/home-active.png'),
            libraryIcon: require('@/assets/img/icons/navbar/library.png'),
            libraryIconActive: require('@/assets/img/icons/navbar/library-active.png'),
            storeIcon: require('@/assets/img/icons/navbar/store.png'),
            storeIconActive: require('@/assets/img/icons/navbar/store-active.png'),
            challengeIcon: require('@/assets/img/icons/navbar/challenges.png'),
            challengeIconActive: require('@/assets/img/icons/navbar/challenges-active.png'),
            logoutIcon: require('@/assets/img/icons/navbar/logout.png'),
        }
    },
    mounted() {
        this.setElements()
        switch (this.$router.currentRoute.path) {
            case '/user/library':
                this.setLibrary()
                break
            case '/user/challenge':
                this.setChallenge()
                break
            case '/user/store':
                this.setStore()
                break
            case '/user/home':
                this.setHome()
                break
            default:
                this.selected = -1
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
        }),
        items() {
            return [
                {
                    title: this.$t('navigation.home'),
                    trasl: this.$i18n.locale === 'es' ? 'Home' : 'Inicio',
                    icon:  this.homeIconActive,
                    iconW: this.homeIcon,
                    path: '/user/home',
                    name: 'home',
                },
                {
                    title: this.$t('navigation.library'),
                    trasl: this.$i18n.locale === 'es' ? 'Library' : 'Biblioteca',
                    icon:  this.libraryIconActive,
                    iconW: this.libraryIcon,
                    path: '/user/library',
                    name: 'library',
                },
                {
                    title: this.$t('navigation.challenges'),
                    trasl: this.$i18n.locale === 'es' ? 'Challenges' : 'Desafíos',
                    icon: this.challengeIconActive,
                    iconW: this.challengeIcon,
                    path: '/user/challenge',
                    name: 'challenge',
                },
                {
                    title: this.$t('navigation.store'),
                    trasl: this.$i18n.locale === 'es' ? 'Store' : 'Tienda',
                    icon: this.storeIconActive,
                    iconW: this.storeIcon,
                    path: '/user/store',
                    name: 'store',
                },
                {
                    title: this.$t('navigation.logout'),
                    trasl: this.$i18n.locale === 'es' ? 'Log out' : 'Salir',
                    icon:  this.logoutIcon,
                    path: '',
                    name: 'logout',
                },
            ]
        },
    },
    methods: {
        setElements() {
            this.elementBeforeHome = document.getElementById('elem_home_be')
            this.elementHome = document.getElementById('elem_home')
            this.elementAfterHome = document.getElementById('elem_home_af')
            this.elementListFirst = document.getElementById('elem_list_fi')
            this.elementLibrary = document.getElementById('elem_library')
            this.elementChallenge = document.getElementById('elem_challenge')
            this.elementStore = document.getElementById('elem_store')
            this.elementListLast = document.getElementById('elem_list_la')
        },
        cleanHome() {
            this.elementBeforeHome.classList.remove('brb')
            this.elementAfterHome.classList.remove('brt')
        },
        cleanLibrary() {
            this.elementListFirst.classList.remove('brb')
            this.elementChallenge.classList.remove('brt')
        },
        cleanChallenge() {
            this.elementLibrary.classList.remove('brb')
            this.elementStore.classList.remove('brt')
        },
        cleanStore() {
            this.elementChallenge.classList.remove('brb')
            this.elementListLast.classList.remove('brt')
        },
        setHome() {
            this.elementBeforeHome.classList.add('brb')
            this.elementAfterHome.classList.add('brt')
            this.selected = 0
        },
        setLibrary() {
            this.elementListFirst.classList.add('brb')
            this.elementChallenge.classList.add('brt')
            this.selected = 1
        },
        setChallenge() {
            this.elementLibrary.classList.add('brb')
            this.elementStore.classList.add('brt')
            this.selected = 2
        },
        setStore() {
            this.elementChallenge.classList.add('brb')
            this.elementListLast.classList.add('brt')
            this.selected = 3
        },
        async logOut() {
            const vm = this
            this.$modal.confirm(
                'Confirmar',
                '¿Quieres cerrar tu sesión?',
                async () => {
                    await accessHistory.setLogout({ userId: this.user.id })
                        .then((response) => console.info(response))
                        .catch((error) => console.error(error));
                    vm.$store.dispatch('clearSession').then(() => {
                        setTimeout(() => {
                            window.location.href = process.env.VUE_APP_BEEREADERS_LOGIN_URL
                        }, 100)
                    })
                }
            )
        },
    },
    watch: {
        $route(to, from) {
            switch (from.path) {
                case '/user/library':
                    this.cleanLibrary()
                    break
                case '/user/challenge':
                    this.cleanChallenge()
                    break
                case '/user/store':
                    this.cleanStore()
                    break
                case '/user/home':
                    this.cleanHome()
                    break
                default:
                    break
            }

            switch (to.path) {
                case '/user/library':
                    setTimeout(() => {
                        this.setLibrary()
                    }, 10)
                    break
                case '/user/challenge':
                    setTimeout(() => {
                        this.setChallenge()
                    }, 10)
                    break
                case '/user/store':
                    setTimeout(() => {
                        this.setStore()
                    }, 10)
                    break
                case '/user/home':
                    setTimeout(() => {
                        this.setHome()
                    }, 10)
                    break
                default:
                    this.selected = -1
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.navbar{
  // align-items: stretch;
  background-color: white;
  left: 0;
  max-width: 144px;
  min-height: 100vh;
  padding: 0 20px;
  position: fixed;
  top: 0;
  z-index: 5;
  overflow: hidden;
  .navbar-item{
    width: 100%;
    @media (min-width: 959px) {
      padding: 0;
      & > .row{
        padding: 5px 10px 5px 0!important;
      }
    }
  }
  @media (max-width: 959px) {
    bottom: 0;
    box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.03);
    height: auto;
    min-height: inherit;
    max-width: 100%;
    padding: 4px 0 0;
    top: inherit;
    width: 100%;
    .v-list--nav .v-list-item{
      // padding: 0 15px;
      &--disabled{
        height: 0;
        min-height: 0;
        margin: 0;
        padding: 0;
          &:not(:last-child):not(:only-child){
          height: 0;
          min-height: 0;
          margin: 0;
          padding: 0;
        }
      }
      &-group{
        display: flex;
        flex-direction: row;
        &--link{
          flex-direction: column;
        }
      }
      .v-image{
        height: 36px;
        width: 36px;
      }
    }
  }
}
.selected {
  background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
  border-radius: 8px;
  box-shadow: 0px -14px 29px 0px #705EBF4D;
  position: relative;

  @media (min-width: 959px) {
    background: url('../../assets/img/icons/navbar/background.svg') no-repeat;
    background-size: 100% 100%;
    padding: 0 1em;
    overflow: visible;
    box-shadow: none;
    &::after{
      content: '';
      box-shadow: -5px 0px 40px 15px #705EBF4D;
      display: block;
      width: 0px;
      height: 100%;
      position: absolute;
      right: -10px;
      top: 0;
    }
  }
}
.v-list-item {
    min-height: 24px;
  &--active{
    .v-list-item__title{
      color: white;
    }
  }
  &__title{
    color: #514585;
    &.title-es{
      font-weight: 600;
      font-size: .9rem;
      & + div{
        font-size: .8rem!important;
      }
    }
  }
}
</style>
